import { useState } from "react";
import styled from "styled-components";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import Input from "./text-input";

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

// const SelectButton = styled(Button)`
//   background: #efefef;
//   box-shadow: none;
//   color: #888;
//   flex-shrink: 0;
//   font-size: 0.9rem;
//   height: 36px;
//   padding: 8px 16px;
//   position: absolute;
//   right: 10px;
//   top: 10px;
//   margin: 0;
//   width: 160px;
//   white-space: nowrap;
//   @media (max-width: 900px) {
//     padding: 12px;
//     width: 120px;
//   }

//   &:hover {
//     background: #efefef;
//   }

//   &:active {
//     background: #ddd;
//     box-shadow: none;
//     color: #555;
//   }
// `;

const SelectButton = styled.button`
  background: #efefef;
  border: none;
  border-radius: 100px;
  color: #888;
  flex-shrink: 0;
  font-size: 1.125rem;
  cursor: pointer;
  font-weight: 600;
  padding: 8px 16px;
  width: 120px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ScaleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
`;

const Scale = styled.div`
  border: 1px solid #ccc;
  display: flex;
  align-items: center;
  & > div:last-child {
    border-right: none;
  }
`;

const ScaleOption = styled.div`
  background: ${(props) =>
    props.selected ? props.theme.color.primary : "white"};
  border-right: 1px solid #ccc;
  color: ${(props) => (props.selected ? "white" : "default")};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.125rem;
  width: 48px;
  height: 48px;
  cursor: pointer;
`;

const LinearScale = ({ min, max, minLabel, maxLabel, handleMinmax, handleMinLabel, handleMaxLabel, selected }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [options, setOptions] = useState([]);
  const [scaleValue, setScaleValue] = useState("");

  // Ensure minLabel and maxLabel have default values

  // const handleClick = (e, type) => {
  //   setAnchorEl(e.currentTarget);
  //   const options = [];
  //   if (type === "min") {
  //     for (let i = 0; i <= 1; i++) {
  //       options.push(
  //         <MenuItem key={i} onClick={() => handleDropDown(i, type)}>
  //           {i}
  //         </MenuItem>
  //       );
  //     }
  //   } else {
  //     for (let i = 2; i <= 10; i++) {
  //       options.push(
  //         <MenuItem key={i} onClick={() => handleDropDown(i, type)}>
  //           {i}
  //         </MenuItem>
  //       );
  //     }
  //   }
  //   setOptions(options);
  // };

  // const handleDropDown = (value, type) => {
  //   setAnchorEl(null);
  //   if (type === "min") {
  //     handleMinmax(value, max);
  //   } else {
  //     handleMinmax(min, value);
  //   }
  // };

  const scaleOptions = [];
  for (let i = min; i <= max; i++) {
    scaleOptions.push(
      <ScaleOption
        key={i}
        onClick={() => setScaleValue(i)}
        selected={scaleValue === i}
      >
        {i}
      </ScaleOption>
    );
  }

  return (
    <>
      {selected && (
        <>
          {/* Range is only 1-5, may change later*/}
          {/* <Container>
            <SelectButton onClick={(e) => handleClick(e, "min")}>
              <p>{min}</p>
            </SelectButton>
            <p>to</p>
            <SelectButton onClick={(e) => handleClick(e, "max")}>
              <p>{max}</p>
            </SelectButton>
          </Container> */}

          <Input
            width="330px"
            type="text"
            value={minLabel}
            onChange={(e) => handleMinLabel(e.target.value)}
            label={`Min label`}
            placeholder="Label (optional)"
          />
          <Input
            width="330px"
            type="text"
            value={maxLabel}
            onChange={(e) => handleMaxLabel(e.target.value)}
            label={`Max label`}
            placeholder="Label (optional)"
          />
        </>
      )}

      <ScaleContainer>
        <p>{minLabel}</p>
        <Scale>{scaleOptions}</Scale>
        <p>{maxLabel}</p>
      </ScaleContainer>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        {options}
      </Menu>
    </>
  );
};

export default LinearScale;
